import React, { lazy, FC } from 'react';
import { PartialRouteObject } from 'react-router';
import { useRoutes } from 'react-router-dom';
import WrapperRouteComponent from './config';

import { Login } from '@app/modules/Auth';
import * as Layout from '@app/modules/Layout';
import * as Dashboard from '@app/modules/Dashboard';
import * as Report from '@app/modules/Report';
import * as Rooms from '@app/modules/Rooms';
import * as TemperatureProfiles from '@app/modules/Profiles/Temperature';
import * as CronTemplates from '@app/modules/Profiles/Schedule';
import * as Tenants from '@app/modules/Tenants';
import * as Analyze from '@app/modules/Analyze';
import { SiderMenuItem } from '@app/common/Layout';

// const Login = lazy(() => import(/* webpackChunkName: "404'"*/ '../modules/Auth/pages/Login'));
const NotFound = lazy(() => import(/* webpackChunkName: "404'"*/ '../modules/404'));

const routes: SiderMenuItem[] = [
  {
    id: '0',
    icon: 'dashboard',
    name: Dashboard.routes.name,
    route: Dashboard.routes.path
  },
  {
    breadcrumbParentId: '0',
    id: '1',
    icon: 'bar-chart',
    name: Report.routes.name,
    route: Report.routes.path
  },
  // {
  //   breadcrumbParentId: '0',
  //   id: '2',
  //   icon: 'analyze',
  //   name: Analyze.routes.name,
  //   route: Analyze.routes.path
  // },
  {
    breadcrumbParentId: '0',
    id: '3',
    icon: 'apartment',
    name: Rooms.routes.name,
    route: Rooms.routes.path
  },
  {
    breadcrumbParentId: '0',
    id: '4',
    icon: 'control',
    name: 'Profiles',
    route: ''
  },
  {
    breadcrumbParentId: '4',
    menuParentId: '4',
    id: '6',
    icon: 'control',
    name: TemperatureProfiles.routes.name,
    route: TemperatureProfiles.routes.path
  },
  {
    breadcrumbParentId: '4',
    menuParentId: '4',
    id: '7',
    icon: 'control',
    name: CronTemplates.routes.name,
    route: CronTemplates.routes.path
  },
  {
    breadcrumbParentId: '0',
    id: '5',
    icon: 'team',
    name: Tenants.routes.name,
    route: Tenants.routes.path
  }
];

const routeList: PartialRouteObject[] = [
  {
    path: 'login',
    element: <WrapperRouteComponent element={<Login />} titleId="title.login" />
  },
  {
    path: '',
    element: <WrapperRouteComponent element={<Layout.Page routes={routes} />} titleId="title.default" />,
    children: [
      {
        path: Dashboard.routes.path,
        element: <WrapperRouteComponent element={<Dashboard.Page />} titleId="title.dashboard" auth />
      },
      {
        path: Report.routes.path,
        element: <WrapperRouteComponent element={<Report.Page />} titleId="title.report" auth />
      },
      {
        path: Analyze.routes.path,
        element: <WrapperRouteComponent element={<Analyze.Page />} titleId="title.analyze" auth />
      },
      {
        path: Rooms.routes.path,
        element: <WrapperRouteComponent element={<Rooms.Page />} titleId="title.rooms" auth />
      },
      {
        path: Tenants.routes.path,
        element: <WrapperRouteComponent element={<Tenants.Page />} titleId="title.tenants" auth />
      },
      {
        path: TemperatureProfiles.routes.path,
        element: <WrapperRouteComponent element={<TemperatureProfiles.Page />} titleId="title.profiles" auth />
      },
      {
        path: CronTemplates.routes.path,
        element: <WrapperRouteComponent element={<CronTemplates.Page />} titleId="title.profiles" auth />
      },
      {
        path: '*',
        element: <WrapperRouteComponent element={<NotFound />} titleId="title.notFount" />
      }
    ]
  }
];

const RenderRouter: FC = () => {
  const element = useRoutes(routeList);
  return element;
};

export default RenderRouter;
